import { createSlice } from '@reduxjs/toolkit';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

const initialState = {
  selectedLocation: null,
  loading: false,
};

export const gisSearchSlice = createSlice({
  name: 'gisSearch',
  initialState: initialState,
  reducers: {
    setSelectedLocation: (state, action) => {
      return {
        ...state,
        selectedLocation: action.payload,
      };
    },
    clearSelectedLocation: state => {
      return {
        ...state,
        selectedLocation: null,
      };
    },
  },
  extraReducers: {
    ['incidents/setSelectedAlertID']: () => {
      return initialState;
    },
    ['FORCED_LOGOUT_SUCCESS']: () => {
      return initialState;
    },
    ['LOGOUT_SUCCESS']: () => {
      return initialState;
    },
    ['SINATRA_LOGOUT']: () => {
      return initialState;
    },
  },
});

export const {
  setSelectedLocation,
  clearSelectedLocation,
} = gisSearchSlice.actions;

const persistConfig = {
  key: 'gisSearch',
  storage,
  blacklist: ['selectedLocation'],
};
const persistedReducer = persistReducer(persistConfig, gisSearchSlice.reducer);

export default persistedReducer;
